module.exports = __webpack_public_path__ + "img/usingeggs.735892d9.jpg";